import React from 'react';
import {Box, Chip} from '@mui/material';
import {CalendarMonthOutlined, ContentCopyOutlined} from '@mui/icons-material';
import {Bolt} from '@mui/icons-material'; // Añadido 'Pause' y AutoAwesome
import iconHotmart from '../../assets/icon_hotmart.png';
import iconKiwify from '../../assets/icon_kiwify.png';
import iconPandaVideo from '../../assets/icon_pandavideo.png';
import iconShopify from '../../assets/icon_shopify.png';
import iconClickFunnels from '../../assets/icon_clickfunnels.png';
import iconStripe from '../../assets/icon_stripe.png';

const FunnelIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path fill="#5b8c06" d="M2 4.5C2 2.2 6.5 2 12 2C17.5 2 22 2.2 22 4.5C22 8.5 16.5 12 14 13L13.2 21.5C13.2 22.3 10.8 22.3 10.8 21.5L10 13C7.5 12 2 8.5 2 4.5Z"/>
        <path fill="#ffffff" d="M3.8 4.5C3.8 5.6 7.5 6 12 6C16.5 6 20.2 5.6 20.2 4.5C20.2 3.4 16.5 3 12 3C7.5 3 3.8 3.4 3.8 4.5Z"/>
    </svg>
);

const CardViewAdFooter = ({index, item, activityIndicatorCircle, inactivityIndicatorCircle}) => {
// Convert Unix epoch format to JavaScript Date object
const UnixToTimeTimestamp = (Unixtime) => {
    const date = new Date(Unixtime * 1000); // Convert Unix timestamp (seconds) to milliseconds
    return date;
};

// Get the current date in Unix epoch format
const TimeTimestampToUnix = () => {
    const currentTimeMillis = Date.now();
    const unixTime = Math.floor(currentTimeMillis / 1000);
    return unixTime;
};

// Calculate the days since publication
const calculateDaysSincePublication = (startDate) => {
    console.log("el startDate: ", startDate);
    //console.log("el item es", item);
    const startDateObj = UnixToTimeTimestamp(startDate);
    const currentDateObj = UnixToTimeTimestamp(TimeTimestampToUnix());
    const timeDifference = currentDateObj - startDateObj;
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    return daysDifference;
}; 

const daysSincePublication = calculateDaysSincePublication(item.startDate);

const getCodeBelongsIcon = (codeBelongs) => {
    if (!codeBelongs || !Array.isArray(codeBelongs)) {
        return null;
    }

    if (codeBelongs.includes('Hotmart')) {
        return iconHotmart;
    }
    if (codeBelongs.includes('Kiwify')) {
        return iconKiwify;
    }
    if (codeBelongs.includes('ClickFunnels')) {
        return iconClickFunnels;
    }
    if (codeBelongs.includes('Stripe')) {
        return iconStripe;
    }
    if (codeBelongs.includes('Panda')) {
        return iconPandaVideo;
    }
    if (codeBelongs.includes('Shopify')) {
        return iconShopify;
    }

    return null;
};

const codeBelongsIcon = getCodeBelongsIcon(item?.codeBelongs);
const shouldShowFunnelIcon = item?.embudo_landingPage != null;


  
        return (
            <div className="card-footer">
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 0.5, px: 1, pb: 0.5 }}>
                    {
                        codeBelongsIcon
                            ? <>
                                {shouldShowFunnelIcon && (
                                    <Box
                                        component="span"
                                        sx={{
                                            display: 'inline-flex',
                                            '@keyframes funnelBlink': {
                                                '0%, 49.999%': { opacity: 1 },
                                                '50%, 100%': { opacity: 0 }
                                            },
                                            animation: 'funnelBlink 2s steps(1, end) infinite'
                                        }}
                                    >
                                        <FunnelIcon />
                                    </Box>
                                )}
                                <img src={codeBelongsIcon} alt="checkout" style={{width: 20, height: 20, objectFit: 'contain'}}/>
                            </>
                            : <Bolt sx={{ color: '#facc15', fontSize: 20 }} />
                    }
                </Box>
                            
                {
                    item?.duplicates >= 1 && (
                        <div className={"card-footer-items"}
                             id="duplicados">
                            <span>{item?.duplicates} anuncios</span>
                        </div>
                    )
                }
                <div className={"card-footer-items"}
                     id="diasCorriendo">
                    {
                        daysSincePublication > 1
                            ? (<p>Hace {daysSincePublication + " Días"}</p>)
                            : (<p>Hace {daysSincePublication + " Día"}</p>)
                    }
                    <img src={item?.Active === true ? activityIndicatorCircle : inactivityIndicatorCircle}/>
                </div>
            </div>);
    }
;

export default CardViewAdFooter;